import { ComponentProps } from 'react'

import { useSearchFilterStore } from '@/entities/map'
import { Filter, useFilterOptions } from '@/features/room-filter'

import { FilterDialogTrigger } from '../filter-dialog'

export const FilterMenuList = () => {
  const hasChanged = useSearchFilterStore(state => state.hasChanged)

  const { FILTER_OPTIONS } = useFilterOptions()

  return (
    <div className="mr-4 flex gap-1.5">
      <FilterDialogTrigger>
        <Filter.All />
      </FilterDialogTrigger>

      {FILTER_OPTIONS.map(({ title, type, field, width }) => (
        <FilterDialogTrigger
          key={type}
          target={type as ComponentProps<typeof FilterDialogTrigger>['target']}
        >
          <Filter.Item width={width} selected={hasChanged(field)}>
            {title}
          </Filter.Item>
        </FilterDialogTrigger>
      ))}
    </div>
  )
}
